<div mat-dialog-title fxLayout="row" fxLayoutAlign="start start">
  <h2>Recaptcha</h2>
</div>

<mat-dialog-content id="recaptcha_container">
  <div class="py-5" id="recaptcha_fallback"></div>
</mat-dialog-content>